'use strict';

var ERRORS = {
    MAIN:  { status: -100, errorMsg: 'Ошибка сети или сервера.' },
    ABORT: { status: -101, errorMsg: '', statusAbort: true },
    WRONG: { status: -102, errorMsg: 'Получены неверные данные от сервера.' },
};


function reponseError(response) {
    var error;

    if (response.xhrStatus === 'abort') {
        error = {
            status: ERRORS.ABORT.status,
            errorMsg: ERRORS.ABORT.errorMsg
        }
    } else {
        error = {
            status: response.status || ERRORS.MAIN.status,
            errorMsg: response.statusText || ERRORS.MAIN.errorMsg
        };
    }

    //console.warn('@itbelcom/check-response.error 1: ', error);
    return Promise.reject(error);
} /* reponseError */


function responseSuccess(response) {
    //console.info('@itbelcom/check-response.success 1: response.data =', response.data);
    var error;
    var data = response && response.data || {};

    if (data.Status === 0) {
        return response;
    } else if (data.Status) {
        error = {
            status: data.Status,
            errorMsg: data.ErrorMsg || ERRORS.MAIN.errorMsg
        };
    } else {
        error = {
            status: ERRORS.WRONG.status,
            errorMsg: ERRORS.WRONG.errorMsg
        };
    }
    //console.warn('@itbelcom/check-response.success 2: detect ERROR:', error);
    return Promise.reject(error);
} /* responseSuccess */


module.exports = {
    error: reponseError,
    success: responseSuccess
};



//////////////////
// WEBPACK FOOTER
// ../node_modules/@itbelcom/check-response/src/check-response.js
// module id = 303
// module chunks = 0 1 2